module.exports = __webpack_public_path__ + "img/2.de06abe9.jpg";